import React from 'react';
import './Landing.scss';

const Landing = () => {
  return (
    <div className="landing-container">
      <h1 className="landing-header">We've Moved!</h1>
      <p className="landing-text">
        Our new website is now at <a href="https://runthemix.com" className="bold link">runthemix.com</a>
      </p>
      <a href="https://runthemix.com">
        <button className="landing-button">
          CLICK HERE to Visit New Site
        </button>
      </a>
    </div>
  );
};

export default Landing;
